import api from './api';

const locationService = {
  // Get nearby locations based on center coordinates
  async getNearbyLocations(lat, lng, searchTerm = '') {
    try {
      const response = await api.get('/members/nearby', {
        params: {
          search: searchTerm,
          lat: lat,
          lon: lng
        }
      });

      return response.data
    } catch (error) {
      console.error('Get locations error:', error);
      throw error;
    }
  },

  // Search locations by address or name
  async searchLocations(query) {
    try {
      const response = await api.get('/locations/search', {
        params: {
          q: query
        }
      });

      // Transform the response data to match the expected format
      const locations = response.data.map(location => ({
        id: location.id || location._id,
        name: location.name,
        address: location.address,
        latitude: location.latitude || location.lat,
        longitude: location.longitude || location.lng,
        type: location.type,
        phone: location.phone,
        hours: location.hours,
        loyaltyPartners: location.loyaltyPartners || location.loyalty_partners || []
      }));

      return { locations };
    } catch (error) {
      console.error('Search locations error:', error);
      throw error;
    }
  },

  // Get location details by ID
  async getLocationDetails(locationId) {
    try {
      const response = await api.get(`/locations/${locationId}`);

      // Transform the response data to match the expected format
      const location = {
        id: response.data.id || response.data._id,
        name: response.data.name,
        address: response.data.address,
        latitude: response.data.latitude || response.data.lat,
        longitude: response.data.longitude || response.data.lng,
        type: response.data.type,
        phone: response.data.phone,
        hours: response.data.hours,
        loyaltyPartners: response.data.loyaltyPartners || response.data.loyalty_partners || []
      };

      return response;
    } catch (error) {
      console.error('Get location details error:', error);
      throw error;
    }
  },

  // Enroll in a group
  async enrollInGroup(group_id) {
    try {
      const response = await api.post('/members/enroll', { group_id });
      return response.data;
    } catch (error) {
      console.error('Enroll in location error:', error);
      throw error;
    }
  }
};

export default locationService;